
import type { PointOfInterest } from "./types";
import { initialPois } from "./initial-data";

// This function now returns the static POI data from the local file.
// It simulates an async fetch to match the expected signature.
export async function getPois(): Promise<PointOfInterest[]> {
  try {
    // Return the hardcoded data from the initial-data file
    return initialPois;
  } catch (error) {
    console.error("Error loading initial POIs:", error);
    // Return an empty array in case of an error to prevent app crash
    return [];
  }
}
